import { beCertainID } from '../../../../common/videos/localized.js';

// Module-level constants
const VIDEO_POSTER = 'https://4imprintweb.blob.core.windows.net/qtzdev/video/2016/vidthumb-shadow-lg.jpg';
const VIDEO_URL_PREFIX = 'https://cdnv.4imprint.com/encoded/';
const VIDEO_CAPTION_URL = 'https://cdn.4imprint.com/vid/captions/';
const SPRITE_URL_SUFFIX = '/sprites/low/sprite.vtt';
const STREAM_SUFFIX = '/stream.mpd';
const HLS_SUFFIX = '/index.m3u8';
const CAPTION_SUFFIX = '.vtt';

/**
 * Handles info video logic for 4imprint.
 */
class InfoVideos4i {
    constructor() {
        this.player = null;
    }

    /**
     * Initialize and play the "Why Buy" video.
     * @param {boolean} [startPlayback=false]
     */
    async initWhyBuy(startPlayback = false) {
        const source = {
            title: 'Be certain with 4imprint',
            dash: VIDEO_URL_PREFIX + beCertainID + STREAM_SUFFIX,
            hls: VIDEO_URL_PREFIX + beCertainID + HLS_SUFFIX,
            subtitleTracks: [{
                url: VIDEO_CAPTION_URL + beCertainID + CAPTION_SUFFIX,
                id: 'track-0',
                label: 'English',
                lang: 'en'
            }],
            thumbnailTrack: {
                url: VIDEO_URL_PREFIX + beCertainID + SPRITE_URL_SUFFIX
            },
            poster: VIDEO_POSTER
        };
        await this.playVideo(source, "Be Certain with 4imprint", beCertainID, startPlayback);
    }

    /**
     * Initialize and play the Mug Imprint video.
     * @param {boolean} [startPlayback=false]
     */
    async initMugImprint(mugImprintID, startPlayback = false) {
        const source = {
            title: "Video for Mug Imprint Options",
            dash: VIDEO_URL_PREFIX + mugImprintID + STREAM_SUFFIX,
            hls: VIDEO_URL_PREFIX + mugImprintID + HLS_SUFFIX,
            subtitleTracks: [{
                url: VIDEO_CAPTION_URL + mugImprintID + CAPTION_SUFFIX,
                id: 'track-0',
                label: 'English',
                lang: 'en'
            }],
            thumbnailTrack: {
                url: VIDEO_URL_PREFIX + mugImprintID + SPRITE_URL_SUFFIX
            },
            poster: VIDEO_POSTER
        };
        await this.playVideo(source, "Mug Imprints", mugImprintID, startPlayback);
    }

    /**
     * Play a video with the given configuration.
     * @param {object} playVidSourceConfig
     * @param {string} playVidTitle
     * @param {string} playVidID
     * @param {boolean} startPlayback
     */
    async playVideo(playVidSourceConfig, playVidTitle, playVidID, startPlayback) {
        const playerConfig = {
            key: 'a8072f85-5072-454b-b8f2-09087b192aa7',
            analytics: {
                key: '26a9da30-39dd-4906-bf18-2b222b809d92',
                title: playVidTitle,
                videoId: playVidID,
            },
        };
        const playerContainer = document.getElementById("player");
        if (!playerContainer) {
            console.error("Player container not found");
            return;
        }
        if (this.player) {
            await this.player.destroy();
        }
        this.player = new bitmovin.player.Player(playerContainer, playerConfig);
        await this.player.load(playVidSourceConfig);
        await this.getTranscript(playVidID);
        if (startPlayback) {
            this.player.play();
        }
    }

    /**
     * Fetch and display the transcript for a video.
     * @param {string} videoID
     */
    async getTranscript(videoID) {
        const url = `/video/Transcript/${videoID}`;
        const transcriptContainer = document.getElementById("transcriptContainer");
        const errorText = '<p class="text16">Oops, looks like there was either a problem getting the transcript or we may not have one completed yet.</p>';
        if (!transcriptContainer) {
            console.error("Transcript container not found");
            return;
        }
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
            });
            const responseJSON = await response.json();
            transcriptContainer.innerHTML = responseJSON.transcripttext !== ""
                ? `<p class="text16">${responseJSON.transcripttext}</p>`
                : errorText;
        } catch (error) {
            console.error(error);
            transcriptContainer.innerHTML = errorText;
        }
    }
}

export default new InfoVideos4i();